export class DownloadFile {
    constructor () {      
        this.header = ['FILE_ID','SAVE_NAME'];        
        this.data = [{
          FILE_ID: '',
          SAVE_NAME: ''          
        }];        
    }
}